export default __webpack_public_path__ + "static/media/calendar.b634ece5.svg";